<div
  class="bg-bluegray-100 fixed bottom-0 notification-panel"
  [class.minimized]="minimized"
  style="z-index: 998">
  <div class="px-3 py-1 flex flex-wrap align-items-center">
    <div class="notification-grid p-2">
      <crm-global-search></crm-global-search>
    </div>
    <div class="flex mr-3">
      <crm-notification-list
        *ngIf="listShowNotification.includes(NotificationKind.PURCHASE)"
        icon="pi-table"
        header="Закупки"
        [informerType]="NotificationKind.PURCHASE"></crm-notification-list>
      <crm-notification-task-list
        *ngIf="listShowNotification.includes(NotificationKind.TASK)"
        icon="pi-dollar"
        header="Платежи"></crm-notification-task-list>
      <crm-notification-list
        *ngIf="listShowNotification.includes(NotificationKind.PROJECT)"
        icon="pi-check-square"
        header="Задачи"
        [informerType]="NotificationKind.PROJECT"></crm-notification-list>
      <crm-notification-list
        *ngIf="listShowNotification.includes(NotificationKind.PERSONAL)"
        icon="pi-user"
        header="Личные"
        [informerType]="NotificationKind.PERSONAL"></crm-notification-list>
      <crm-notification-list
        *ngIf="listShowNotification.includes(NotificationKind.HELPDESK)"
        icon="pi-question-circle"
        header="HelpDesk"
        [informerType]="NotificationKind.HELPDESK"></crm-notification-list>
      <crm-notification-list
        *ngIf="listShowNotification.includes(NotificationKind.VARIANCE)"
        icon="pi-exclamation-circle"
        header="Отклонения"
        [informerType]="NotificationKind.VARIANCE"></crm-notification-list>
      <crm-notification-list
        *ngIf="listShowNotification.includes(NotificationKind.MAILING)"
        icon="pi-envelope"
        header="Рассылки"
        [informerType]="NotificationKind.MAILING"></crm-notification-list>
      <crm-notification-list
        *ngIf="listShowNotification.includes(NotificationKind.DEAL)"
        icon="pi-briefcase"
        header="Сделки"
        [informerType]="NotificationKind.DEAL"></crm-notification-list>
      <crm-notification-expired-list *ngIf="isShowExpiredNotification"></crm-notification-expired-list>
      <crm-notification-favorites-list
        *ngIf="listShowNotification.includes(NotificationKind.PROJECT)"></crm-notification-favorites-list>
    </div>
  </div>
</div>

<p-toast
  key="notification"
  position="bottom-right"
  styleClass="notification-toast"
  #toast>
  <ng-template
    let-message
    pTemplate="message">
    <div
      *ngIf="toSocketNotification(message.data) as notification"
      class="w-full cursor-pointer"
      (click)="onNotificationClick(toast, notification)">
      <h4 class="mt-0 mb-3 font-bold">{{ notification.subject?.title || 'Новое уведомление' }}</h4>
      <h4 class="mt-0 mb-1 font-medium">{{ notification?.user?.profile?.name || notification?.externalUser?.profile?.name || 'Сервисное уведомление' }}</h4>
      <p
        class="notification-text break-word"
        [innerHTML]="notification.text | truncate: 70 | safeHtml"></p>
    </div>
  </ng-template>
</p-toast>
